module.exports = __webpack_public_path__ + "static/images/power-list3.9619e09.png";